// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"OY-z","subtitle":"PY-z","wrapper":"QY-z","leftArrow":"RY-z","rightArrow":"SY-z"};